<template>
	<WasteRequestForm />
</template>

<script>
import WasteRequestForm from "../components/WasteRequestForm";

export default {
	components: {
		WasteRequestForm,
	},
};
</script>
